var map = {
	"./Affogato.png": 8416,
	"./Americano.png": 6651,
	"./Cappuccino.png": 8071,
	"./Caramel-Machiato.png": 3732,
	"./Chocolate Ice Cream.png": 9629,
	"./Chocolate Milkshake.png": 6737,
	"./Choose Milkshake Flavor.png": 2477,
	"./Churro Doughnut.png": 772,
	"./Churro Ice Cream Sandwich.png": 9340,
	"./Churro Waffle Ice Cream Sandwich.png": 6040,
	"./Churro Waffle.png": 8502,
	"./Churros Con Chocolate.png": 6528,
	"./Coffee Milkshake.png": 3295,
	"./Crepetastic.png": 6678,
	"./Dulce De Leche Ice Cream.png": 4881,
	"./Espresso Shake.png": 1981,
	"./Espresso.png": 1109,
	"./Gluten Free Sampler.png": 8595,
	"./Gluten Free Stuffed Churros.png": 2056,
	"./Gluten Free Stuffed.png": 3031,
	"./Horchata Latte.png": 8514,
	"./Hot Chocolate.png": 9001,
	"./Hot Tea.png": 9043,
	"./Iced Chamomile.png": 4641,
	"./Iced Coffee.png": 3186,
	"./Iced Ginger Mint Tea.png": 9718,
	"./Iced Horchata Latte.png": 4844,
	"./Iced Latte.png": 2141,
	"./Iced Matcha.png": 4782,
	"./Iced Passion Berry.png": 6050,
	"./Iced Rooibos.png": 90,
	"./Matcha Latte.png": 607,
	"./Mocha.png": 8664,
	"./Nutella Cappucino.png": 1289,
	"./Oreo Ice Cream.png": 4960,
	"./Oreo Mint Milkshake.png": 7718,
	"./Plain Churros.png": 3477,
	"./Rose Water.png": 3411,
	"./Spanish Latte.png": 9236,
	"./Strawberry Milkshake.png": 5476,
	"./Stuffed Churros.png": 842,
	"./Stuffed Sampler.png": 3595,
	"./Sweet Latte.png": 8510,
	"./Vanilla Ice Cream.png": 7866,
	"./Vegan Salted Caramel & Chocolate Ice Cream.png": 5882,
	"./no-image.png": 4925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6425;